import { render } from "./SimpleEdit_copy_for_D.vue?vue&type=template&id=0547b0b7"
import script from "./SimpleEdit_copy_for_D.vue?vue&type=script&lang=js"
export * from "./SimpleEdit_copy_for_D.vue?vue&type=script&lang=js"
script.render = render

export default script